import Swiper from "../../../static/js/swiper.min.js"; /* if use swiper.min.js */

export default {
    methods: {
        projectInit() {
            const winWindow = window.outerWidth;
            this.rwdImg(winWindow,712,1280);
            this.progressBar();

            //접근시 페이지 상단으로 이동
            $('html,body').stop().animate({ scrollTop: 0 }, 0);

            var fnThis = this;
            var resizeDoit;
            $(window).on('resize',function(){
                var winW = $(this).outerWidth();
                clearTimeout(resizeDoit);
                resizeDoit = setTimeout(function(){
                    fnThis.rwdImg(winW,712,1280);
                },250);
            });
        },
        projectSwiper() {
            if($('.swiper-wrapper').length){
                
            }
        },
        rwdImg(winW, bpT, bpW) {
            var newSrc;
            $('img').each(function(){
                var dataSrc = String($(this).attr('data-src'));
                dataSrc = dataSrc.replace(/ /gi, "");
                var dataBreak = String($(this).attr('data-break'));
                dataBreak = dataBreak.replace(/ /gi, "");
                var dataException = String($(this).attr('data-exception'));

                if(dataSrc != 'undefined' || !dataSrc.length){
                    if(dataBreak == 'undefined' || !dataBreak.length){//각각 이미지가 있을 때
                        if(winW < bpT){//Mobile
                            if(dataException.indexOf('mobile') <= -1) newSrc = dataSrc.replace('@t.','@m.').replace('@w.','@m.');
                        }else if(winW < bpW){//Tablet
                            if(dataException.indexOf('tablet') <= -1) newSrc = dataSrc.replace('@m.','@t.').replace('@w.','@t.');
                        }else{//PC
                            if(dataException.indexOf('web') <= -1) newSrc = dataSrc.replace('@t.','@w.').replace('@m.','@w.');
                        }
                    }else if(dataBreak == 'mt-w'){//Mobile Tablet 이미지 같이 사용
                        if(winW < bpW){//Mobile & Tablet
                            newSrc = dataSrc.replace('@w.','@mt.');
                        }else{//PC
                            newSrc = dataSrc.replace('@mt.','@w.');
                        }
                    }else if(dataBreak == 'm-tw'){//Tablet Web 이미지 같이 사용
                        if(winW < bpT){//Mobile
                            newSrc = dataSrc.replace('@tw.','@m.');
                        }else{//Tablet & PC
                            newSrc = dataSrc.replace('@m.','@tw.');
                        }
                    }
                    $(this).attr('src', newSrc);
                }
            });
        },
        progressBar() {
            if($('.progress-indicator').length) $('.progress-indicator').remove();

            var progressIndicator = '<div class="progress-indicator"></div>';
            $('.layer-project').append(progressIndicator);
            $(window)
                .off('scroll')
                .on('scroll', function () {
                    var currentPercentage = ($(window).scrollTop() / ($(document).outerHeight() - $(window).height())) * 100;
                    $('.progress-indicator').width(currentPercentage+'%');
                });

        }
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/projectCommon.js